import React from "react";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import "./list-report-modal.scss";

class ListReportModal extends React.Component {
    render() {
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal add-report"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">Reports</h4>
                </div>

                <div className="report-body">
                    <p>
                        <Link to="/retention/report">Retention Report</Link>
                    </p>
                </div>
            </ReactModal>
        );
    }
}

export default ListReportModal;
